export default {
  customerUrl: null,
  list: null,
  loading: false,
  mutating: false
}
